import React, { Fragment, Component } from 'react'
import { Link } from 'gatsby'
import styled, { injectGlobal } from 'styled-components'
import { Flex, Box } from 'grid-styled'
import Space from 'styled-space'
import Carousel from 'nuka-carousel'
import { Helmet } from 'react-helmet'
// import Media from 'react-media'
import Media from '../components/Media'
import Layout from '../layouts/'
import Container from '../components/Container'
import Footer from '../components/Footer'
import H1 from '../components/H1'
import Text from '../components/P'
import reaktorPoster from '../images/reaktor-josh@2x.png'
import aiPoster from '../images/ai-poster@2x.png'
import aiPoster1 from '../images/ai-poster-1.png'
import aiPoster2 from '../images/ai-poster-2.png'
import katapultPoster from '../images/katapult-front-2.png'
import newsState from '../images/news/Stateofimpact_43.jpg'
import newsHelle from '../images/news/Helle_H_43.jpg'
import newsMuch from '../images/news/Munchmuseet_43.jpg'
import newsHurtigruten from '../images/news/hurtigruten_43.jpg'
import newsArkivet from '../images/news/Arkivet_43.jpg'
import newsOya from '../images/news/Oya_43.jpg'
import newsAi from '../images/news/Elements_43.jpg'
import newsSpeak from '../images/news/speak.jpg'
import newsCopyright from '../images/news/Andsverkloven_43.jpg'

injectGlobal`
  /*! minireset.css v0.0.3 | MIT License | github.com/jgthms/minireset.css */html,body,p,ol,ul,li,dl,dt,dd,blockquote,figure,fieldset,legend,textarea,pre,iframe,hr,h1,h2,h3,h4,h5,h6{margin:0;padding:0}h1,h2,h3,h4,h5,h6{font-size:100%;font-weight:normal}ul{list-style:none}button,input,select,textarea{margin:0}html{box-sizing:border-box}*,*:before,*:after{box-sizing:inherit}img,embed,iframe,object,audio,video{height:auto;max-width:100%}iframe{border:0}table{border-collapse:collapse;border-spacing:0}td,th{padding:0;text-align:left}
  @font-face {
    font-family: "everett-regular";
    src: url(/fonts/Everett-Regular-web.eot);
    src: url(/fonts/Everett-Regular-web.eot?#iefix)
        format("embedded-opentype"),
      url(/fonts/Everett-Regular-web.woff) format("woff"),
      url(/fonts/Everett-Regular-web.woff2) format("woff2"),
      url(/fonts/Everett-Regular-web.ttf) format("truetype");
    font-weight: normal;
    font-style: normal;
  }
  @font-face {
    font-family: "everett-mono";
    src: url(/fonts/EverettMono-Regular-web.eot);
    src: url(/fonts/EverettMono-Regular-web.eot?#iefix)
        format("embedded-opentype"),
      url(/fonts/EverettMono-Regular-web.woff) format("woff"),
      url(/fonts/EverettMono-Regular-web.woff2) format("woff2"),
      url(/fonts/EverettMono-Regular-web.ttf) format("truetype");
    font-weight: normal;
    font-style: normal;
  }
  @font-face {
    font-family: "everett-bold";
    src: url(/fonts/Everett-Bold-web.eot);
    src: url(/fonts/Everett-Bold-web.eot?#iefix)
        format("embedded-opentype"),
      url(/fonts/Everett-Bold-web.woff) format("woff"),
      url(/fonts/Everett-Bold-web.woff2) format("woff2"),
      url(/fonts/Everett-Bold-web.ttf) format("truetype");
    font-weight: normal;
    font-style: normal;
  }
  body {
    font-family: everett-regular, system-ui,sans-serif;
    color: #212121;
    overflow-x: hidden;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    /* background-image: url(/images/1280.png);
    background-size: cover;
    background-repeat: no-repeat; */
  }

  ::selection {
    background: #5257B0;
    color: #fff;
    }
    ::-moz-selection {
      background: #5257B0;
    }

  a {
    color: #212121;
    text-decoration: none;
  }

  a > p {
    border-bottom: 1px solid #212121;
    display: table;
  }

  a:hover {
    color: #5257B0;
  }
  .slider-frame {
    /* min-height: 460px; */
  }
  .slider-list {
    /* min-height: 250px; */
    cursor: grab !important;
  }
  .slider-slide {
    /* bottom: 0px; */
    /* top: auto !important; */
  }
  .ai__link:hover ~ .sc-bdVaJa img:first-of-type,
  .ai__link:focus ~ .sc-bdVaJa img:first-of-type {
    transform: translate(-5px, 5px);
  }
  .ai__link:hover ~ .sc-bdVaJa img:last-of-type,
  .ai__link:focus ~ .sc-bdVaJa img:last-of-type {
    transform: translate(5px, -5px);
  }
  .reaktor__link:hover ~ .sc-bdVaJa svg .eyebrow {
    transform: translateY(-3px);
  }
  .embedVideoIframe {
    position: absolute;
    width: 100%;
    top: 0;
    bottom: 0;
    left: 0;
    height: 100%;
  }
  .row__reverse {
    @media screen and (max-width: 40em) {
      flex-direction: column-reverse;
    }
  }
`

const Row = props => <Flex {...props} mx={'-1.5625vw'} />

const Column = props => <Box {...props} px={'1.5625vw'} flex='1 1 auto' />

const H2 = styled.h2`
  font-size: 1.6vw;
  line-height: 150%;

  @media (max-width: 40em) {
    font-size: 18px;
  }
`

const P = styled.p`
  font-family: everett-mono, system-ui, sans-serif;
  font-size: 1.5625vw;
  line-height: 145%;
  letter-spacing: -0.03828125vw;

  @media (max-width: 40em) {
    font-size: 17px;
    letter-spacing: -1px;
  }

  @media (min-width: 48em) and (max-width: 60em) {
    font-size: 17px;
    letter-spacing: -1px;
  }
`

const SubText = styled.p`
  font-family: everett-mono, system-ui, sans-serif;
  font-size: 1.32vw;
  line-height: 143%;
  letter-spacing: -0.078125vw;
  color: ${props => props.theme.colors[props.color]};

  @media (max-width: 40em) {
    font-size: 17px;
    letter-spacing: -1px;
  }

  @media (min-width: 48em) and (max-width: 60em) {
    font-size: 17px;
    letter-spacing: -1px;
  }
`

SubText.defaultProps = {
  as: 'p',
  color: 'gray'
}

const Image = styled.img`
  vertical-align: top;
  max-width: 100%;
  height: auto;
  width: 100%;
  @media (max-width: 40em) {
    margin-bottom: 40px;
  }
`

const AiImages = styled.div`
  position: relative;
  @media screen and (min-width: 40em) {
    margin-left: calc(100% / 12 * 1);
  }
  @media screen and (min-width: 52em) {
    margin-left: calc(100% / 12 * 2);
  }
  img {
    position: relative;
    transition: transform 0.2s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  }
  img:first-of-type {
    position: absolute;
    top: 2vw;
    left: -4vw;
  }
  img:last-of-type {
    position: relative;
    top: -2vw;
  }
`

const WorkLink = styled(Link)`
  display: block;
  p {
    border-bottom: 0;
  }
  p:first-of-type {
    border-bottom: 1px solid #212121;
    display: table;
  }
  &:hover,
  &:focus {
    p {
      color: #212121;
    }
    p:first-of-type {
      color: #5257b0;
      border-color: #5257b0;
    }
    .arrow {
      transform: translateX(2px);
    }
  }
  .arrow {
    display: inline-block;
    transform: translateX(-2px);
    transition: transform 0.13s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  }
`

const ReaktorSvg = styled.div`
  display: block;
  @media (max-width: 40em) {
    margin-bottom: 25px;
  }
  .st0 {
    fill: #afbdde;
  }
  .st1 {
    fill: #761b42;
  }
  .st2 {
    fill: #efb773;
  }
  .st3 {
    fill: #5858a6;
  }
  .st4 {
    fill: #11734a;
  }
  .st5 {
    fill: #ffffff;
  }
  .st6 {
    fill: #141536;
  }
  .eyebrow {
    transition: transform 0.15s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  }
`

class IndexPage extends Component {
  constructor (props) {
    super(props)
    this.hoverImages = React.createRef()
  }
  state = {
    slidesToShow: 3.65
  }

  updateSlidesToShow = slidesToShow => {
    this.setState({ slidesToShow: slidesToShow })
  }

  render () {
    return (
      <Layout>
        <Fragment>
          <Helmet>
            <title>Feed</title>
            <meta
              name='description'
              content='Feed designs ambitious brands and digital products.'
            />
          </Helmet>
          <Media
            query='(max-width: 40em)'
            onChange={matches => matches && this.updateSlidesToShow(1.05)}
          />
          <Media
            query='(min-width: 48em) and (max-width: 60em)'
            onChange={matches => matches && this.updateSlidesToShow(2.2)}
          />
          <Container>
            <Box mb={'14.53125vw'} width={[1, 1, '80%']}>
              <H1>Feed designs ambitious brands and digital products.</H1>
            </Box>

            <Row
              flexWrap={['wrap', 'nowrap']}
              alignItems='center'
              justifyContent='center'
              mb={['90px', '8.28125vw']}
            >
              <Column
                className='reaktor__link'
                order={[2, 1]}
                width={[12 / 12, 4 / 12]}
                ml={[0, 'calc(100% / 12 * 1)', 'calc(100% / 12 * 2)']}
              >
                <WorkLink className='link' to='/work/reaktor/'>
                  <Space mb={3}>
                    <P>
                      Reaktor's new home <span className='arrow'>→</span>
                    </P>
                  </Space>
                  <P>
                    Together with Reaktor we designed and built their new digital home and refined
                    visual identity.
                  </P>
                </WorkLink>
              </Column>
              <Column
                order={[1, 2]}
                width={[12 / 12, 4 / 12]}
                mr={[0, 'calc(100% / 12 * 1)', 'calc(100% / 12 * 2)']}
              >
                <ReaktorSvg>
                  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 464.2 476.6'>
                    <path
                      className='st0'
                      d='M170.2,187.5c-0.2-0.8-0.3-1.6-0.4-2.4c0.2,1.6,0.4,3.2,0.6,4.8c-2.8-22.2,4.4-44.8-0.2-66.9	c-1.9-9.3-13.3-15.5-22.2-12.6c-9.8,3.2-14.7,12.3-12.6,22.2c0.2,0.8,0.3,1.6,0.4,2.4c-0.2-1.6-0.4-3.2-0.6-4.8	c2.8,22.2-4.4,44.8,0.2,66.9c1.9,9.3,13.3,15.5,22.2,12.6C167.4,206.6,172.3,197.4,170.2,187.5L170.2,187.5z'
                    />
                    <path
                      className='st1'
                      d='M304.1,187.7c-8.7,18.6-17.3,37.2-26,55.8c-3,6.4-2,14.9,4.9,18.5c6,3.2,15.3,2,18.5-4.9	c8.7-18.6,17.3-37.2,26-55.8c3-6.4,2-14.9-4.9-18.5C316.6,179.7,307.3,180.8,304.1,187.7L304.1,187.7z'
                    />
                    <path
                      className='st2'
                      d='M242.7,312c13.2-0.5,26.4-4.1,37-12.1c10.8-8.1,19.5-18.8,25.6-30.8c4.1-8,7.3-16.6,10.4-25 c3.7-10,7-20.1,9.8-30.4c3-10.9,5.8-22.5,5.8-33.9c0.1-9.4-8.3-18.5-18-18c-9.8,0.4-18,7.9-18,18c0,2.6-0.3,5.1-0.6,7.6 c0.2-1.6,0.4-3.2,0.6-4.8c-1.6,11.4-4.7,22.6-8.2,33.6c-3.3,10.7-7.1,21.3-11.4,31.6c0.6-1.4,1.2-2.9,1.8-4.3 c-2.9,6.9-6.4,13.3-10.8,19.5c-1.4,2,1-1.4,1.3-1.6c-0.4,0.4-0.7,0.9-1.1,1.3c-0.8,1-1.6,1.9-2.4,2.8c-1.5,1.6-3.1,3.2-4.8,4.7 c-0.6,0.5-2.6,2.1,0,0c2.5-1.9,0.9-0.7,0.3-0.3c-0.9,0.6-1.9,1.3-2.8,1.9c-1.9,1.2-3.9,2.2-6,3c1.4-0.6,2.9-1.2,4.3-1.8 c-3.8,1.5-7.8,2.6-11.9,3.1c1.6-0.2,3.2-0.4,4.8-0.6c-1.9,0.2-3.8,0.4-5.7,0.5c-9.4,0.3-18.5,8.1-18,18 C225,303.5,232.6,312.4,242.7,312L242.7,312z'
                    />
                    <path
                      className='st2'
                      d='M200.2,45.9c5.7-2.1,11.6-3.6,17.7-4.5c-1.6,0.2-3.2,0.4-4.8,0.6c7.9-1.1,15.9-1.1,23.9,0 c-1.6-0.2-3.2-0.4-4.8-0.6c7.6,1.1,15.1,3.1,22.2,6.1c-1.4-0.6-2.9-1.2-4.3-1.8c5.5,2.4,10.8,5.2,15.7,8.6c0.6,0.5,1.3,0.9,1.9,1.4 c2.4,1.7-2.8-2.3-1.1-0.9c1.1,0.9,2.1,1.7,3.1,2.6c2.2,1.9,4.3,3.9,6.2,6c1.9,2,3.7,4.1,5.4,6.2c1.4,1.7-2.6-3.5-0.9-1.1 c0.4,0.5,0.7,1,1.1,1.5c0.9,1.3,1.8,2.5,2.6,3.8c3.2,5,5.9,10.2,8.2,15.6c-0.6-1.4-1.2-2.9-1.8-4.3c3.3,8.1,5.7,16.5,6.9,25.2 c-0.2-1.6-0.4-3.2-0.6-4.8c0.4,3.1,0.7,6.2,0.8,9.4c0.4,9.4,8,18.5,18,18c9.4-0.4,18.5-7.9,18-18c-1.2-27.1-11.3-52.7-28.8-73.3 c-17.9-21.1-43.5-33.2-70.7-36c-14.5-1.5-29.8,0.4-43.5,5.5c-4.5,1.7-8.3,4-10.8,8.3c-2.3,3.9-3.2,9.6-1.8,13.9 C180.8,42,190.7,49.4,200.2,45.9L200.2,45.9z'
                    />
                    <path
                      className='st2'
                      d='M282.4,324.2c1-10.1,2.1-20.2,3.1-30.3c0.4-4.3-2.3-9.8-5.3-12.8c-3.1-3.1-8.3-5.5-12.8-5.3 c-4.7,0.2-9.5,1.7-12.8,5.3c-3.4,3.7-4.8,7.7-5.3,12.8c-1,10.1-2.1,20.2-3.1,30.3c-0.4,4.3,2.3,9.8,5.3,12.8 c3.1,3.1,8.3,5.5,12.8,5.3c4.7-0.2,9.5-1.7,12.8-5.3C280.5,333.3,281.9,329.2,282.4,324.2L282.4,324.2z'
                    />
                    <path
                      className='st3'
                      d='M324.3,165.9c4-9.5,3.2-20.9-4.3-28.5c-9.7-9.9-27.6-9.4-34.8,3.4c-6.1,10.9-2.6,25.3,8.5,31.5 c4.1,2.3,9.3,3.7,14.1,3.3c5.9-0.5,10.1-2.2,15.5-4.5c3.9-1.6,7.2-6.9,8.3-10.8c1.2-4.3,0.7-10.1-1.8-13.9 c-2.5-3.9-6.2-7.2-10.8-8.3c-1.6-0.2-3.2-0.4-4.8-0.6c-3.3,0-6.3,0.8-9.1,2.5c-0.3,0.1-0.6,0.2-0.8,0.4c1.4-0.6,2.9-1.2,4.3-1.8 c-1.7,0.7-3.3,1.3-5.1,1.6c1.6-0.2,3.2-0.4,4.8-0.6c-1,0.1-2,0.1-3,0c1.6,0.2,3.2,0.4,4.8,0.6c-0.5-0.1-0.9-0.2-1.4-0.4 c1.4,0.6,2.9,1.2,4.3,1.8c-0.7-0.3-1.2-0.6-1.9-1c1.2,0.9,2.4,1.9,3.7,2.8c-0.4-0.3-0.7-0.6-1-1c0.9,1.2,1.9,2.4,2.8,3.7 c-0.3-0.4-0.5-0.7-0.6-1.2c0.6,1.4,1.2,2.9,1.8,4.3c-0.1-0.4-0.2-0.8-0.3-1.3c0.2,1.6,0.4,3.2,0.6,4.8c0-0.4,0-0.9,0.1-1.3 c-0.2,1.6-0.4,3.2-0.6,4.8c0.1-0.2,0.1-0.4,0.2-0.6c-0.6,1.4-1.2,2.9-1.8,4.3c0.1-0.4,0.3-0.8,0.6-1.1c-0.9,1.2-1.9,2.4-2.8,3.7 c0.1-0.2,0.3-0.3,0.4-0.5c-1.2,0.9-2.4,1.9-3.7,2.8c0.3-0.3,0.7-0.5,1.1-0.6c-1.4,0.6-2.9,1.2-4.3,1.8c0.2,0,0.4-0.1,0.6-0.1 c-1.6,0.2-3.2,0.4-4.8,0.6c0.4-0.1,0.8,0,1.3,0.1c-1.6-0.2-3.2-0.4-4.8-0.6c0.2,0.1,0.4,0.1,0.6,0.2c-1.4-0.6-2.9-1.2-4.3-1.8 c0.4,0.2,0.8,0.4,1.2,0.6c-1.2-0.9-2.4-1.9-3.7-2.8c0.6,0.5,1,0.9,1.5,1.5c-0.9-1.2-1.9-2.4-2.8-3.7c0.3,0.4,0.5,0.8,0.7,1.2 c-0.6-1.4-1.2-2.9-1.8-4.3c0.2,0.5,0.3,1,0.3,1.5c-0.2-1.6-0.4-3.2-0.6-4.8c0.1,0.6,0.1,1.2,0,1.7c0.2-1.6,0.4-3.2,0.6-4.8 c-0.3,2.1-1,4-1.8,6c-1.7,4-0.3,10.3,1.8,13.9c2.2,3.7,6.5,7.3,10.8,8.3c4.6,1.1,9.8,0.8,13.9-1.8c1.2-0.9,2.4-1.9,3.7-2.8 C321.9,171.6,323.5,168.9,324.3,165.9L324.3,165.9z'
                    />
                    <path
                      className='st3'
                      d='M240.6,157.8c1.5-4.3,1.3-9.3,0-13.6c-1.8-5.9-5.5-9.8-10.4-13.4c-3.4-2.5-10-3.1-13.9-1.8 c-4.4,1.4-8.4,4.1-10.8,8.3c-1.3,2.3-2.6,4.5-3.9,6.8c-3.6,6.4-3,14.3,1.4,20c4,5.2,12.3,9.1,19,6.5c5.1-2,10.1-4,15.2-5.9 c3.8-1.5,6.8-3.2,9.4-6.5c2.4-3,4.1-7,3.9-10.9c-0.3-7.6-5.3-15.7-13.2-17.4c-0.8-0.2-1.6-0.3-2.4-0.5c-9.2-2-19.9,2.7-22.2,12.6 c-2.1,9.1,2.7,20.1,12.6,22.2c0.8,0.2,1.6,0.3,2.4,0.5c0-11.6,0-23.2,0-34.8c-5.1,2-10.1,4-15.2,5.9c6.8,8.8,13.6,17.7,20.4,26.5 c1.3-2.3,2.6-4.5,3.9-6.8c-8.2,2.2-16.5,4.3-24.7,6.5c-4.5-5.5-6-6.9-4.5-4.2c-0.6-1.4-1.2-2.9-1.8-4.3c0.2,0.5,0.4,0.9,0.5,1.4 c-0.2-1.6-0.4-3.2-0.6-4.8c0.1,0.5,0.1,1,0.1,1.5c0.2-1.6,0.4-3.2,0.6-4.8c-0.1,0.5-0.2,1-0.4,1.5c-3.1,8.9,3.5,20.1,12.6,22.2 C228.4,172.7,237.3,167.4,240.6,157.8L240.6,157.8z'
                    />
                    <path
                      className='st3'
                      d='M234.9,135.8c-2.8-3.2-5.6-6.5-8.4-9.7c-2.9-3.3-8.5-5.3-12.8-5.3c-4.4,0-9.7,2-12.8,5.3 c-3.2,3.4-5.5,8-5.3,12.8c0.2,5,2,9,5.3,12.8c2.8,3.2,5.6,6.5,8.4,9.7c2.9,3.3,8.5,5.3,12.8,5.3c4.4,0,9.7-2,12.8-5.3 c3.2-3.4,5.5-8,5.3-12.8C239.9,143.6,238.1,139.6,234.9,135.8L234.9,135.8z'
                    />
                    <path
                      className='st4'
                      d='M268.7,341.1c-10.3,2-18.9,10.6-21.6,20.6c-3,11.2,2.5,24.5,13,29.7c11.4,5.6,25.2,2,31.3-9.5 c6.1-11.3,2.6-24.9-8.1-31.9c-6-4-14.6-2.8-20,1.4c-6.1,4.7-7.8,11.6-6.5,19c3.1,17.9,5.8,35.9,9.6,53.7 c3.7,17.3,10,34.3,22.3,47.3c6.5,6.9,19.1,7,25.5,0c6.8-7.4,6.9-18.2,0-25.5c-0.6-0.7-1.3-1.4-1.9-2.1c-0.5-0.6-2.3-2.8-0.3-0.3 c1.9,2.5,0.2,0.2-0.2-0.4c-0.5-0.8-1-1.5-1.5-2.3c-1.8-2.9-3.3-6-4.6-9.1c0.6,1.4,1.2,2.9,1.8,4.3c-4.4-10.7-6.6-22-8.6-33.3 c-2.5-13.9-4.9-27.9-7.3-41.8c-8.8,6.8-17.7,13.6-26.5,20.4c-1.6-0.9-2.8-2-3.8-3.5c-1.1-1.6-1.4-1.9-0.8-0.8 c-0.6-1.4-1.2-2.9-1.8-4.3c0.1,0.4,0.2,0.7,0.3,1.1c-0.2-1.6-0.4-3.2-0.6-4.8c0.1,0.6,0.1,1.2,0,1.8c0.2-1.6,0.4-3.2,0.6-4.8 c-0.1,0.6-0.2,1.2-0.5,1.8c0.6-1.4,1.2-2.9,1.8-4.3c-0.8,1.8-1.7,1.9,1.6-1.6c-1.8,1.9,4.2-2.6,1.7-1.5c1.4-0.6,2.9-1.2,4.3-1.8 c-0.2,0.1-0.4,0.1-0.6,0.2c1.6-0.2,3.2-0.4,4.8-0.6c-0.5,0.1-1,0.1-1.5,0.1c1.6,0.2,3.2,0.4,4.8,0.6c-0.5-0.1-1-0.2-1.5-0.4 c1.4,0.6,2.9,1.2,4.3,1.8c-2-0.9-1.5-1.8,1.1,1.1c0.6,0.8,1.2,1.6,1.8,2.4c-0.3-0.5-0.6-0.9-0.8-1.4c0.6,1.4,1.2,2.9,1.8,4.3 c-0.3-0.8-0.5-1.5-0.6-2.4c0.2,1.6,0.4,3.2,0.6,4.8c-0.1-0.5,0-1.1,0-1.6c-0.2,1.6-0.4,3.2-0.6,4.8c0.2-0.9,0.4-1.6,0.7-2.5 c-0.6,1.4-1.2,2.9-1.8,4.3c0.2-0.5,0.5-1,0.8-1.5c-2,2.5-2.4,3-1.2,1.7c-3.9,3.6-1.8,1.3-0.1,0.6c-1.4,0.6-2.9,1.2-4.3,1.8 c0.8-0.3,1.6-0.5,2.4-0.7c9.3-1.8,15.4-13.4,12.6-22.2C287.7,343.8,278.7,339.2,268.7,341.1L268.7,341.1z'
                    />
                    <path
                      className='st0'
                      d='M250.5,288.2c-6.4-3.1-12.4-6.7-18.1-10.8c-0.8-0.6-1.6-1.2-2.4-1.7c-2.5-1.8,2.6,2.1,0.9,0.7 c-1.4-1.1-2.8-2.3-4.2-3.4c-2.7-2.3-5.4-4.6-8.1-6.9c-5.1-4.4-10.2-8.9-14.8-13.8c-1.2-1.3-2.4-2.6-3.5-3.9c-0.4-0.5-0.8-1-1.2-1.5 c3.5,4.1,1.3,1.7,0.6,0.7c-1.9-2.7-3.6-5.7-4.9-8.7c0.6,1.4,1.2,2.9,1.8,4.3c-1.1-2.8-1.9-5.6-2.4-8.6c0.2,1.6,0.4,3.2,0.6,4.8 c-0.2-1.7-0.3-3.5-0.2-5.2c-0.2,1.6-0.4,3.2-0.6,4.8c0.3-2.5,1.2-4.8,2.1-7.1c-0.6,1.4-1.2,2.9-1.8,4.3c4-9.3,10.6-18.4,10.6-28.9 c0-9.1-5.3-17.2-13.7-20.8c-6-2.5-12.3-4.1-18.3-6.6c1.4,0.6,2.9,1.2,4.3,1.8c-3.8-1.6-7.4-3.5-10.9-5.8c-1.7-1.1,4,3.5,1.7,1.3 c-0.5-0.5-1-0.9-1.4-1.4c-2.3-2.3,2,3.1,1.5,2c-0.2-0.5-0.6-1-0.8-1.5c0.6,1.4,1.2,2.9,1.8,4.3c-0.3-0.7-0.5-1.4-0.6-2.1 c0.2,1.6,0.4,3.2,0.6,4.8c-0.1-0.7-0.1-1.4,0-2.1c-0.2,1.6-0.4,3.2-0.6,4.8c0.1-0.9,0.4-1.8,0.7-2.6c-0.6,1.4-1.2,2.9-1.8,4.3 c0.3-0.7,0.7-1.4,1.1-2c0.2-0.3,0.4-0.6,0.6-0.9c1.5-2.4-2.9,3.5-1.7,2.2c1.3-1.3,2.4-2.7,3.8-3.9c2.9-2.7,6-5.1,9-7.6 c9.2-7.7,17.2-18.2,14-31c-1.2-4.9-4.3-9.5-6.7-13.9c-2.8-4.9-6-9.7-8.2-14.9c0.6,1.4,1.2,2.9,1.8,4.3c-1.6-4-2.7-8.1-3.3-12.4 c0.2,1.6,0.4,3.2,0.6,4.8c-0.7-5.7-0.6-11.3,0.1-17c-0.2,1.6-0.4,3.2-0.6,4.8c1.5-10.9,5.3-21.3,9.6-31.4c-0.6,1.4-1.2,2.9-1.8,4.3 c1.2-2.7,2.3-5.4,3.5-8.2c2-4.6,3.2-8.8,1.8-13.9c-1.2-4.2-4.4-8.7-8.3-10.8c-4.2-2.2-9.3-3.3-13.9-1.8c-4.2,1.3-8.9,4.1-10.8,8.3 c-8,18.4-16.2,37.2-16.2,57.6c0,10.6,2.2,20.8,6.6,30.4c3.5,7.7,8.8,14.6,12.3,22.3c-0.6-1.4-1.2-2.9-1.8-4.3 c0.2,0.5,0.3,1,0.4,1.5c-0.2-1.6-0.4-3.2-0.6-4.8c0.1,0.5,0.1,1,0,1.5c0.2-1.6,0.4-3.2,0.6-4.8c-0.1,0.6-0.3,1.2-0.5,1.8 c0.6-1.4,1.2-2.9,1.8-4.3c-0.4,0.8-0.8,1.5-1.3,2.3c-1.4,2.3,3-3.6,1.8-2.4c-0.4,0.4-0.8,0.9-1.2,1.3c-1.6,1.6-3.3,3.1-5,4.6 c-3.7,3.1-7.6,6.1-11.1,9.5c-6,6-10.6,13.4-10.9,22.1c-0.4,8.7,4,17,10.7,22.5c4.5,3.7,9.2,6.6,14.6,8.9c3.8,1.7,7.6,3.2,11.5,4.6 c3.2,1.1,6.6,1.9,9.7,3.2c-1.4-0.6-2.9-1.2-4.3-1.8c1.8,0.9,0.7,1.3-2.3-1.9c0,0-3.1-4.7-2-2.4c-0.6-1.4-1.2-2.9-1.8-4.3 c0.1,0.4,0.2,0.7,0.3,1.1c-0.2-1.6-0.4-3.2-0.6-4.8c0.1,0.7,0.1,1.4,0,2.1c0.2-1.6,0.4-3.2,0.6-4.8c-0.3,1.8-0.9,3.5-1.6,5.2 c0.6-1.4,1.2-2.9,1.8-4.3c-3,7-7,13.6-9.4,20.8c-3.6,10.9-0.9,22.5,3.7,32.6c4.1,9,10.9,16.8,17.9,23.7 c6.6,6.4,13.6,12.5,20.7,18.3c9.2,7.5,18.8,14.5,29.6,19.7c4.4,2.1,9,3.2,13.9,1.8c4.2-1.2,8.7-4.4,10.8-8.3 C261.2,304.8,259.5,292.5,250.5,288.2L250.5,288.2z'
                    />
                    <path
                      className='st0'
                      d='M120.2,153.2c0.7,1.3,1.3,2.7,1.9,4.1c0.2,0.5,0.4,0.9,0.6,1.4c0.9,2-0.5-1.1-0.6-1.5c0.5,1.1,0.9,2.2,1.4,3.4	c2.1,5,4,10.1,6,15.2c3.6,9.2,6.9,18.9,11.5,27.6c3.3,6.3,12.6,8.7,18.5,4.9c6.4-4.1,8.4-11.8,4.9-18.5c-0.7-1.3-1.3-2.7-1.9-4.1	c-0.2-0.5-0.4-0.9-0.6-1.4c-0.9-2,0.5,1.1,0.6,1.5c-0.5-1.1-0.9-2.2-1.4-3.4c-2.1-5-4-10.1-6-15.2c-3.6-9.2-6.9-18.9-11.5-27.6	c-3.3-6.3-12.6-8.7-18.5-4.9C118.7,138.8,116.7,146.4,120.2,153.2L120.2,153.2z'
                    />
                    <path
                      className='st5'
                      d='M269.1,204.5c11.8,0,23-10.3,22.5-22.5s-9.9-22.5-22.5-22.5c-11.8,0-23,10.3-22.5,22.5 C247.1,194.2,256.5,204.5,269.1,204.5L269.1,204.5z'
                    />
                    <path
                      className='st6'
                      d='M317.5,152.9c-0.9,0-1.7-0.3-2.4-0.9c-3.2-2.9-7.4-4.7-11.7-5.1c-4.3-0.3-8.7,0.8-12.3,3.3	c-1.7,1.1-3.9,0.7-5-1s-0.7-3.9,1-5c5-3.3,11-4.9,16.9-4.5c6,0.4,11.7,2.9,16.1,6.9c1.5,1.3,1.6,3.6,0.2,5.1	C319.5,152.6,318.5,152.9,317.5,152.9z'
                    />
                    <path
                      className='st6'
                      d='M238.2,148.8c-0.8,0-1.5-0.2-2.2-0.7c-4.4-3.4-9.9-5.3-15.5-5.4c-5.5-0.1-11.1,1.6-15.6,4.8	c-1.6,1.2-3.9,0.8-5-0.9c-1.2-1.6-0.8-3.9,0.9-5c5.8-4.1,12.9-6.3,20-6.2s14.1,2.6,19.7,6.9c1.6,1.2,1.9,3.5,0.7,5.1	C240.4,148.3,239.3,148.8,238.2,148.8z'
                    />
                    <path
                      className='st6'
                      d='M258.3,350c-1.2,0-2.3-0.6-3-1.7c-1.1-1.7-0.6-3.9,1.1-5c4.9-3.1,10.6-4.9,16.4-5c0,0,0,0,0.1,0	c2,0,3.6,1.6,3.6,3.5c0,2-1.5,3.6-3.5,3.7c-4.4,0.1-8.9,1.4-12.6,3.8C259.7,349.8,259,350,258.3,350z'
                    />
                    <path
                      className='st6'
                      d='M218.3,152.2c-4.8,0-8.7-3.5-8.7-7.9c0-4.3,3.9-7.9,8.7-7.9c4.8,0,8.7,3.5,8.7,7.9	C227,148.6,223.1,152.2,218.3,152.2z M218.3,143.6c-1,0-1.5,0.5-1.5,0.7s0.5,0.7,1.5,0.7s1.5-0.5,1.5-0.7S219.3,143.6,218.3,143.6z'
                    />
                    <path
                      className='st6'
                      d='M302.3,156c-4.8,0-8.7-3.5-8.7-7.9c0-4.3,3.9-7.9,8.7-7.9c4.8,0,8.7,3.5,8.7,7.9S307.1,156,302.3,156z M302.3,147.5c-1,0-1.5,0.5-1.5,0.7s0.5,0.7,1.5,0.7s1.5-0.5,1.5-0.7S303.3,147.5,302.3,147.5z'
                    />
                    <path
                      className='st6'
                      d='M38.4,379.4c-1.5,0-2.9-0.7-3.8-2.1c-1.3-2.1-0.7-4.9,1.4-6.2c32.8-20.9,63.4-45.5,90.8-73.1	c1.8-1.8,4.6-1.8,6.4,0s1.8,4.6,0,6.4c-27.9,28.1-59,53.1-92.4,74.3C40.1,379.1,39.2,379.4,38.4,379.4z'
                    />
                    <path
                      className='st6'
                      d='M231.8,398.7c-1.1,0-2.2-0.4-3-1.1c-6.1-5.4-12.2-10.8-18.4-16.2c-25-22-50.8-44.8-75.2-68.5	c-0.5-0.5-1.1-1-1.7-1.5c-2-1.7-4.5-3.8-5.6-7.2c-1.7-5.4,0.7-10.7,2.2-13.9l10-21.4c2.9-6.3,6.3-13.5,12-18.9	c1.2-1.1,2.9-1.5,4.4-1.1c1.8,0.3,3.2,1.6,3.6,3.5c1.7,7.9,3.6,12.9,8.4,16.6c1.3,1,2.8,2.2,4.4,3.4c5.6,4.3,12.6,9.7,17.7,13	c12,7.7,21,14.7,31.4,22.7c1.6,1.2,3.2,2.5,4.9,3.7c4.2,3.2,8.9,6.3,13.4,9.2c6,3.9,12.2,7.9,17.7,12.6c1.7,1.5,5,4.3,5.3,8.6	c0.2,2.4-0.6,5-2.2,7.3c-8.3,11.8-12.9,21.3-17.6,31.4c-2.4,5-4.8,10.1-7.7,15.5c-0.7,1.2-1.8,2.1-3.2,2.3	C232.3,398.7,232.1,398.7,231.8,398.7z M153.6,262.5c-2,3.2-3.6,6.7-5.2,10.1l-10,21.4c-1.2,2.7-2.4,5.4-1.8,7.3	c0.3,0.9,1.5,1.9,2.8,3c0.7,0.6,1.4,1.2,2.2,1.9c24.2,23.5,50,46.3,74.9,68.2c4.7,4.1,9.4,8.3,14.1,12.4c1.7-3.4,3.3-6.7,4.8-10	c4.7-10,9.6-20.3,18.4-32.7c0.5-0.7,0.6-1.2,0.6-1.5c-0.1-0.2-0.5-0.9-2.1-2.3c-5.1-4.3-11-8.2-16.8-11.9c-4.7-3-9.5-6.2-14-9.6	c-1.7-1.3-3.3-2.5-4.9-3.8c-10.3-7.9-19.1-14.8-30.8-22.3c-5.5-3.5-12.6-9-18.3-13.4c-1.5-1.2-3-2.3-4.3-3.3	C158.1,272.4,155.3,267.6,153.6,262.5z'
                    />
                    <path
                      className='st6'
                      d='M305.2,386.4c-0.4,0-0.9-0.1-1.3-0.2c-7.5-2.3-9-8.6-10.4-14.1c-0.4-1.4-0.8-2.9-1.3-4.4	c-0.5-1.7-1-3.4-1.5-5.2c-1.6-6.8-2.5-8.5-5.9-11.3c-4.8-3.9-8.7-5.5-12-4.9c-1.7,0.3-3.4-0.4-4.3-1.7c-0.3-0.2-0.6-0.4-0.9-0.6	c-1.9-1.6-2.1-4.5-0.4-6.4c2.8-3.2,5.6-6.5,7.9-9.9c8.5-12.9,10.2-29.7,11.6-44.5c0.2-1.8,1.4-3.3,3.1-3.9s3.6,0,4.8,1.3	c4.3,4.9,5.4,11.5,6.3,16.3c0.7,4,2.3,7.9,4,12.1c1.8,4.4,3.7,9,4.5,14c0.6,3.4,1.4,6.9,2.1,10.3c1.1,4.7,2.2,9.5,2.8,14.5	c1.3,10.7-0.2,22-4.8,35.5C308.8,385.2,307,386.4,305.2,386.4z M278.8,337.7c3.7,1,7.6,3.1,11.7,6.5c5.5,4.5,7.1,8.1,9,16.2	c0.3,1.5,0.8,3,1.3,4.6s1,3.2,1.4,4.8c0.3,1.3,0.6,2.4,0.9,3.3c2.4-9,3.1-16.9,2.2-24.3c-0.6-4.6-1.6-9-2.6-13.7	c-0.8-3.5-1.6-7.1-2.2-10.8c-0.7-4-2.3-7.9-4-12.1c-1.1-2.8-2.3-5.7-3.2-8.7c-1.8,10-4.8,20.2-10.6,28.9	C281.4,334.4,280.1,336.1,278.8,337.7z'
                    />
                    <path
                      className='st6'
                      d='M155.7,257.3c-0.1,0-0.1,0-0.2,0c-2.5-0.1-4.4-2.2-4.3-4.7c0.5-11.8-0.1-23.6-1.9-35.2	c-4.5,0.4-9.1-1.4-12.3-4.2c-4.4-3.9-6.5-9.2-8.2-13.9c-2.2-6.1-4-12.3-5.8-18.3l-6.8-22.8c-2.1-7-4-15,0-21.9	c2.5-4.4,7.2-7.5,12.2-8.1c3.7-0.4,6.8,1.2,8.8,2.5c1.1,0.7,1.9,1.5,2.7,2.2c0.4,0.4,1.1,1,1.4,1.2c0.7,0.2,2.9,0.1,4.1,0	c1.1-0.1,2-0.1,3-0.1l40.8,1c2.5-6.6,8.8-11.3,14.8-13.2c7.7-2.4,15.7-1.5,22.7-0.7c4.8,0.5,9.7,1.1,14.5,2.8	c4.1,1.5,9.7,4.4,13.1,10.1c3.4,5.6,3.9,13,1.5,20.7c-4.5,14.4-17.8,25.4-32.3,26.6c-9.5,0.8-19-2.4-25.3-8.7	c-6.6-6.6-10.1-16.2-10.4-28.7l-39.6-1c-0.6,0-1.4,0-2.2,0.1c-2.5,0.1-5.3,0.3-7.7-0.6c-1.9-0.7-3.3-2-4.4-3c-0.5-0.4-1-0.9-1.4-1.1	c-1.8-1.1-2.7-1.2-3.1-1.2c-2.2,0.3-4.3,1.7-5.4,3.6c-2.2,3.8-0.8,9.4,0.8,14.9l6.8,22.8c1.8,5.9,3.6,12,5.7,17.9	c1.4,3.8,2.9,7.7,5.7,10.1c2,1.7,5.3,2.7,7.2,1.3c1.3-0.9,2.9-1.1,4.3-0.5s2.5,1.9,2.8,3.4c2.5,14,3.5,28.3,2.9,42.4	C160.1,255.4,158.1,257.3,155.7,257.3z M196.8,142.8c0.1,10.6,2.7,18.5,7.8,23.5c4.5,4.4,11.3,6.7,18.2,6.1c11-1,21.1-9.3,24.5-20.3	c1.6-5.2,1.4-10.1-0.6-13.5c-1.6-2.7-4.6-4.9-8.4-6.2c-3.9-1.4-8.3-1.9-12.5-2.4c-6.4-0.7-13.1-1.5-19,0.4	c-4.8,1.5-9.6,5.7-9.6,10.7C197.1,141.7,197,142.3,196.8,142.8z'
                    />
                    <path
                      className='st6'
                      d='M258,307.2c-10.6,0-21.2-3.8-30.4-7c-2.3-0.8-3.6-3.4-2.8-5.8c0.8-2.4,3.4-3.6,5.8-2.8	c12.8,4.5,27.3,9.6,39,4.1c7.7-3.6,13.8-10.7,19.7-17.5l0.9-1.1c11-12.8,18.3-23.8,25-38c11.5-24.4,15.5-46.9,13.7-77.7	c-0.1-2.5,1.7-4.6,4.2-4.8c2.5-0.1,4.6,1.7,4.8,4.2c1.9,32-2.5,56.5-14.5,82.1c-7,14.8-14.9,26.8-26.3,40.1l-1.1,1.1	c-6.5,7.5-13.2,15.3-22.6,19.8C268.4,306.3,263.2,307.2,258,307.2z'
                    />
                    <path
                      className='st6'
                      d='M139.4,140.7C139.3,140.7,139.3,140.7,139.4,140.7c-2.5,0-4.5-2.1-4.5-4.6c0.3-25,0.6-53.4,11.9-78.3	c7.7-17,20.6-31.6,37.1-42.1C200.5,5.2,219.1-0.2,237.8,0c18.7,0.3,37.2,6.2,53.4,17.2c16.3,11,28.7,25.9,36,43.1	c9.8,23.3,10.2,49.5,10.5,72.7c0,2.5-2,4.5-4.4,4.6c0,0,0,0-0.1,0c-2.5,0-4.5-2-4.5-4.4c-0.3-22.3-0.7-47.6-9.8-69.3	c-13.4-31.8-46.8-54.3-81.2-54.8c-0.4,0-0.7,0-1.1,0c-34.1,0-67.5,21.4-81.6,52.5c-10.5,23.2-10.8,50.5-11.1,74.7	C143.8,138.7,141.8,140.7,139.4,140.7z'
                    />
                    <path
                      className='st6'
                      d='M281.2,206.3l-14.9,4.4l-16.5-4.7l-10.6-5c-10.1,0.7-19.3,4.8-27.1,9.8c-2.7,1.7-5.3,3.7-6.8,6.1 c-1,1.6-3.9,4.3-0.8,5.1c2.7,0.7,7.4-0.5,9.5-1.1c4.7-1.4,14.9-0.9,19.2-0.7c19,0.6,31,1,49.9,1.7c5.4,0.2,10.6,0.5,15,2.8 c1.8,1,5.8,0.7,8,0.8c3,0.2,3.7-1.4,3.7-3.7s-1.7-4.5-3.5-6.3c-6.2-6.1-13.5-9.6-23.1-11.2L281.2,206.3z'
                    />
                    <path
                      className='st6'
                      d='M306.4,230.1c-0.2,0-0.4,0-0.6,0c-0.4,0-1,0-1.6,0c-3.3,0-6.1-0.1-8.2-1.3c-3.4-1.8-7.7-2.1-13-2.3 c-9.5-0.3-17.2-0.6-25-0.8c-7.7-0.3-15.5-0.5-25-0.8h-1.3c-3.9-0.1-12.9-0.5-16.5,0.6c-3.5,1-8.3,2.1-11.9,1.1 c-3-0.8-4.1-2.7-4.5-3.8c-1.1-3.1,0.8-5.8,2-7.4c0.2-0.3,0.4-0.6,0.5-0.7c2-3.3,5.1-5.5,8.2-7.5c9.8-6.3,19.6-9.9,29.3-10.5 c0.8-0.1,1.5,0.1,2.2,0.4l10.3,4.9l14.9,4.3l12.4-3.7l0.9-1.1c1-1.2,2.6-1.7,4.1-1.5c10.5,1.7,18.7,5.6,25.6,12.4 c2.1,2.1,4.9,5.3,4.9,9.6c0,1,0,4.1-2.3,6.3C310.5,229.4,308.7,230.1,306.4,230.1z M300.1,220.7c0.8,0.2,3,0.3,4.1,0.3 c0.2,0,0.5,0,0.7,0c-0.3-0.5-0.8-1.3-1.9-2.3c-5-5-10.7-7.9-18.2-9.5l-0.1,0.1c-0.6,0.6-1.3,1.1-2.1,1.4l-14.9,4.4 c-0.8,0.2-1.7,0.2-2.5,0l-16.5-4.7c-0.2-0.1-0.5-0.2-0.7-0.3l-9.5-4.5c-7.8,0.8-15.8,3.8-23.9,9c-1.1,0.7-2.3,1.6-3.4,2.4 c0.5-0.1,1-0.3,1.5-0.4c4.6-1.4,12.4-1.2,19.4-0.9h1.2c9.5,0.3,17.2,0.6,25,0.8c7.7,0.3,15.5,0.5,25,0.8 C288.3,217.5,294.6,217.8,300.1,220.7z M300.2,220.8L300.2,220.8L300.2,220.8z M281.2,206.3L281.2,206.3L281.2,206.3z'
                    />
                    <path
                      className='st6'
                      d='M270.2,208.7c-2.9,0-5.9-0.6-8.6-1.9c-1.4-0.6-2.5-1.3-3.7-2c-1-0.6-1.9-1.2-2.8-1.6c-1.9-0.9-4.1-1.3-6.5-1.7	c-1.4-0.3-2.9-0.5-4.5-0.9c-6.4-1.6-10.8-5.2-12.4-10c-0.8-2.4,0.5-4.9,2.9-5.7s4.9,0.5,5.7,2.9c0.6,1.7,2.8,3.3,6.1,4.1	c1.2,0.3,2.5,0.5,3.8,0.8c2.8,0.5,5.8,1.1,8.7,2.4c1.4,0.6,2.6,1.4,3.7,2.1c1,0.6,1.9,1.1,2.8,1.6c2.7,1.2,5.9,1.4,8.6,0.4	c3.4-1.2,6.3-4.1,9.4-7.1l0.2-0.2c1.2-1.2,2.1-2.4,2.8-3.8c0.1-0.2,0.2-0.3,0.2-0.5c1-2.3,3.7-3.3,6-2.3s3.3,3.7,2.3,6	c-0.1,0.3-0.3,0.6-0.4,0.9c-1.1,2.2-2.6,4.3-4.5,6.1l-0.2,0.2c-3.5,3.4-7.4,7.3-12.6,9.2C274.9,208.3,272.6,208.7,270.2,208.7z'
                    />
                    <path
                      className='st6'
                      d='M308.1,184.7c-5.2,0-10.3-1.1-15-3.2c-9.4-4.2-16.4-12.5-18.8-22.2c-1.6-6.4-1-13.3,1.5-19.3	c-9.8,0.8-19.8-0.1-29.3-2.7c-2.4-0.7-3.8-3.1-3.2-5.5c0.7-2.4,3.1-3.8,5.5-3.2c11.2,3.1,23,3.5,34.4,1.2	c13.2-7.1,24.9-5.9,35.7-4.1c3.4,0.6,7.7,1.6,11.3,4.2c4.5,3.3,7.5,9.1,8.1,15.7c0.3,3.4-0.1,6.5-0.5,9.5c-0.2,1.7-0.5,3.2-0.5,4.8	c-0.2,4-0.8,8.7-3.4,12.9c-2.5,4-6.5,7.1-12.1,9.2C317.4,183.8,312.7,184.7,308.1,184.7z M287.7,137.7c-4.5,5-6.3,12.6-4.6,19.4	c1.7,6.9,7,13.1,13.8,16.1c6.6,3,14.8,3.1,21.9,0.4c3.7-1.4,6.2-3.3,7.6-5.5c1.6-2.5,1.9-5.6,2.1-8.6c0.1-2,0.4-3.9,0.6-5.7	c0.4-2.6,0.7-5,0.5-7.3c-0.4-4.1-2-7.5-4.5-9.3c-2.1-1.5-4.9-2.2-7.5-2.6C306,132.7,297.3,132.6,287.7,137.7z'
                    />
                    <path
                      className='st6'
                      d='M333.8,157.3c-0.3,0-0.6,0-1-0.1c-2.4-0.5-4-2.9-3.5-5.4c0.4-1.9,1.7-4.5,5.4-6.6c0.6-0.4,1.3-0.7,1.8-0.9	c0.8-0.4,1.5-0.7,2-1.1c0.8-0.6,1-1.8,0.8-2.2c-0.5-0.7-2.5-1.2-3.5-1.5l-13.2-3.7c-2.4-0.7-3.8-3.2-3.1-5.6s3.2-3.8,5.6-3.1	l13.2,3.7c2.3,0.6,6.1,1.7,8.5,5c3.1,4.4,1.9,11-2.7,14.5c-1.2,0.9-2.5,1.5-3.6,2.1c-0.5,0.2-0.9,0.4-1.3,0.7	c-0.6,0.3-0.9,0.6-1,0.7C337.7,155.9,335.8,157.3,333.8,157.3z M338.2,153.9L338.2,153.9L338.2,153.9z'
                    />
                    <path
                      className='st6'
                      d='M137.8,140.1c-1,0-1.9-0.3-2.7-0.9c-1.4-1.1-2.3-2.8-2.3-4.6c0-2,0.9-4,2.4-5.2c2-1.7,4.4-1.8,5.6-1.9	c6.6-0.4,13.1-0.1,19.5,0.2c7.8,0.4,15.2,0.7,22.5-0.2l1.5-0.2c5.7-0.7,10.6-1.2,15.3-3.5c2.2-1.1,4.9-0.2,6,2.1	c1.1,2.2,0.2,4.9-2.1,6c-6.1,3-12,3.7-18.2,4.4l-1.5,0.2c-8.1,1-16.2,0.6-24,0.2c-6.1-0.3-11.8-0.5-17.6-0.2	c-0.1,0.7-0.4,1.4-0.9,1.9C140.5,139.5,139.2,140.1,137.8,140.1z'
                    />
                    <path
                      className='eyebrow eyebrow--1 st6'
                      d='M187.8,134c-0.9,0-1.7-0.2-2.5-0.7c-2.1-1.4-2.7-4.2-1.3-6.2c3-4.6,7.3-8.4,12.2-10.8c5.5-2.7,12.1-4,19.5-3.7	c6.3,0.2,12.5,1.5,18.4,2.7c2.4,0.5,5.8,1.2,8.5,3.4c3.8,3,5.1,8.2,2.9,12c-1.2,2.2-4,2.9-6.1,1.7s-3.3-0.3-2.2-2.5	c-0.1-0.2-2.1-0.3-2.4-0.5c-1.1-0.8-0.7-2.1-2.4-2.4c-5.6-1.1-11.2-0.9-16.8-1.1c-5.9-0.2-10,1.3-14.1,3.4c-3.5,1.8-7.6,2.4-9.8,5.6	C190.7,136.2,189.3,134,187.8,134z'
                    />
                    <path
                      className='eyebrow eyebrow--2 st6'
                      d='M284.3,137c-1.7,0-3.4-1-4.1-2.7c-1.2-2.9-0.7-6.4,1.5-9.1c1.6-2,3.6-3.1,5.4-4c9.7-4.8,21.3-5.9,31.8-3.1	c2.3,0.6,5.7,1.7,8.5,4c3.2,2.6,5.2,6.1,5.3,9.8c0.1,2.5-1.8,4.6-4.3,4.7c-2.5,0.1-6.3-0.4-6.4-2.9c0-1,0,0-1.1-0.9	c-1.2-0.9-3.2-0.5-5.6-1.1c-8.4-2.2-12-3.5-19.8,0.3c-0.8,0.4-1.9,0.5-2.3,1.1c0,0.1-1.2,0.1-1.3,0.2c0.8,2.2-3.4,2.5-5.6,3.4	C285.5,136.9,284.9,137,284.3,137z'
                    />
                    <path
                      className='st6'
                      d='M258.7,395.9c-1.4,0-2.8-0.1-4.2-0.5c-3.7-0.9-7.1-3.2-10.1-6.7l-0.1-0.1c-3.5-4.1-5.8-6.9-6.1-13.5	c-0.1-2.5,1.8-4.6,4.3-4.7s4.6,1.8,4.7,4.3c0.2,3.6,0.9,4.5,4,8.2l0.1,0.1c1.2,1.4,3.1,3.2,5.3,3.7c2.1,0.5,4.7,0,7.2-0.4l22.4-4.1	c1.1-0.2,3.3-0.6,3.9-1.3c2.3-2.8,2.9-6.9,1.9-14c-0.3-2.5,1.4-4.7,3.9-5.1c2.5-0.3,4.7,1.4,5.1,3.9c0.9,6.5,1.2,14.8-4,21	c-2.7,3.2-6.7,3.9-9.1,4.4l-22.4,4.1C263.4,395.5,261.1,395.9,258.7,395.9z'
                    />
                    <path
                      className='st6'
                      d='M273.2,467.5c-1.8,0-3.6-1.1-4.2-3c-6-16.4-9.5-33.5-10.6-51l-0.1-1.7c-0.4-6.7-0.7-13.1-4-17.7	c-1.4-2-1-4.8,1-6.3c2-1.4,4.8-1,6.3,1c4.8,6.7,5.3,15.1,5.7,22.4l0.1,1.7c1,16.6,4.4,32.8,10,48.4c0.8,2.3-0.4,4.9-2.7,5.8	C274.3,467.4,273.7,467.5,273.2,467.5z'
                    />
                    <path
                      className='st6'
                      d='M329.4,466.7c-2.1,0-3.9-1.4-4.4-3.5c-2.8-12-8.8-21.9-14.9-30.8c-9.6-13.9-17-29.1-22.1-45.2	c-0.8-2.4,0.6-4.9,2.9-5.7c2.4-0.8,4.9,0.6,5.7,2.9c4.8,15.2,11.9,29.6,20.9,42.8c6.6,9.6,13.2,20.4,16.3,33.9	c0.6,2.4-1,4.8-3.4,5.4C330,466.7,329.7,466.7,329.4,466.7z'
                    />
                    <path
                      className='st6'
                      d='M422.6,398.6c-1.5,0-2.9-0.7-3.8-2.1c-7.3-11.4-18.6-21.2-34.7-30.2c-8.6-4.8-17.9-9-26.8-13	c-5.5-2.5-11.3-5.1-16.9-7.8c-12.6-6.2-28.6-15-41-28.8c-1.7-1.9-1.5-4.7,0.4-6.4c1.9-1.7,4.7-1.5,6.4,0.4	c8.8,9.9,20.6,18.1,38.2,26.7c5.5,2.7,11.1,5.2,16.6,7.7c9.1,4.1,18.6,8.4,27.5,13.4c17.4,9.7,29.8,20.5,37.9,33.2	c1.3,2.1,0.7,4.9-1.4,6.2C424.3,398.4,423.5,398.6,422.6,398.6z'
                    />
                    <path
                      className='st6'
                      d='M268.4,145.5c-5.8,0-11.6-0.7-17.2-2.1c-2.4-0.6-3.9-3.1-3.3-5.5s3.1-3.9,5.5-3.3c8.6,2.2,17.8,2.4,26.5,0.7	c2.4-0.5,4.8,1.1,5.3,3.6c0.5,2.4-1.1,4.8-3.6,5.3C277.3,145.1,272.8,145.5,268.4,145.5z'
                    />
                    <path
                      className='st6'
                      d='M258,241.4c-14.6,0-29-6.1-42.7-18.3c-1.9-1.7-2-4.5-0.4-6.4c1.7-1.9,4.5-2,6.4-0.4	c13.8,12.3,28.1,17.6,42.4,15.7c4.2-0.6,12.8-4.2,16.8-6.8c0.9-0.5,1.7-1.2,2.6-1.9c1.1-0.9,2.3-1.8,3.7-2.6	c2.1-1.3,4.9-0.6,6.2,1.5c1.3,2.1,0.6,4.9-1.5,6.2c-1,0.6-1.9,1.3-2.9,2.1c-1,0.8-2,1.6-3.2,2.3c-4.4,2.8-14.2,7.3-20.6,8.2	C262.6,241.2,260.3,241.4,258,241.4z'
                    />
                  </svg>
                </ReaktorSvg>
              </Column>
            </Row>

            <Row
              className='row__reverse'
              flexWrap={['wrap', 'nowrap']}
              flexDirection='row-reverse'
              alignItems='center'
              justifyContent='center'
              mb={['90px', '8.28125vw']}
            >
              <Column
                className='ai__link'
                width={[12 / 12, 4 / 12]}
                mr={[0, 'calc(100% / 12 * 1)', 'calc(100% / 12 * 2)']}
              >
                <WorkLink className='link' to='/work/elements-of-ai/'>
                  <Space mb={3}>
                    <P>
                      {' '}
                      <span class='arrow'>←</span> Elements of AI
                    </P>
                  </Space>
                  <P>
                    We partnered with Reaktor and the University of Helsinki to design and build a
                    free online course educating absolutely everyone in artificial intelligence.
                  </P>
                </WorkLink>
              </Column>
              <Column
                width={[12 / 12, 4 / 12]}
                ml={[0, 'calc(100% / 12 * 1)', 'calc(100% / 12 * 2)']}
              >
                <AiImages>
                  <Image src={aiPoster1} alt='' />
                  <Image src={aiPoster2} alt='' />
                </AiImages>
              </Column>
            </Row>

            <Row
              flexWrap={['wrap', 'nowrap']}
              alignItems='center'
              justifyContent='center'
              mb={['90px', '12.8125vw']}
            >
              <Column
                order={[2, 1]}
                width={[12 / 12, 4 / 12]}
                ml={[0, 'calc(100% / 12 * 1)', 'calc(100% / 12 * 2)']}
              >
                <WorkLink className='link' to='/work/katapult/'>
                  <Space mb={3}>
                    <P>
                      Katapult Future Fest <span class='arrow'>→</span>
                    </P>
                  </Space>
                  <P>
                    A two-day festival in Oslo, Norway, focusing on exponential technologies, impact
                    investing and future societies. We designed the identity and website to match
                    their ambitions.
                  </P>
                </WorkLink>
              </Column>
              <Column
                order={[1, 2]}
                width={[12 / 12, 4 / 12]}
                mr={[0, 'calc(100% / 12 * 1)', 'calc(100% / 12 * 2)']}
              >
                <Image src={katapultPoster} alt='' />
              </Column>
            </Row>
          </Container>

          <Box px={['30px', '2.34375vw']}>
            <Row mb={['2.03125vw']}>
              <Column width={[12 / 12, 3 / 12]}>
                <SubText color='black'>News</SubText>
              </Column>
            </Row>
          </Box>

          <Flex px={['30px', '2.34375vw']} pb={'2.5vw'} css={{ overflowX: 'hidden' }}>
            <Carousel
              slidesToShow={this.state.slidesToShow}
              cellAlign='left'
              heightMode='max'
              initialSlideHeight={300}
              // cellSpacing={100}
              slidesToScroll={1}
              swiping
              frameOverflow={'visible'}
              edgeEasing={'easeCircleOut'}
              renderBottomCenterControls={() => null}
              renderCenterLeftControls={() => null}
              renderCenterRightControls={() => null}
            >
              <Box pr={['2.9411764706vw', '0.9765625vw']}>
                <Image src={newsState} alt='' />
                <Space mt={'2vw'}>
                  <SubText color='black'>The State of Impact</SubText>
                </Space>
                <SubText>
                  We designed a magazine about impact tech and investing.{' '}
                  <Link className='link' to='/work/state-of-impact/'>
                    Check it out here.
                  </Link>
                </SubText>
              </Box>

              <Box pr={['2.9411764706vw', '0.9765625vw']}>
                <Image src={newsHurtigruten} alt='' />
                <Space mt={'2vw'}>
                  <SubText color='black'>Hurtigruten Svalbard</SubText>
                </Space>
                <SubText>
                  We can’t wait to show you what’s in store. We’ve partnered with Reaktor to take
                  Hurtigruten Svalbard to a new level.
                </SubText>
              </Box>

              <Box px={['2.9411764706vw', '0.9765625vw']}>
                <Image src={newsArkivet} alt='' />
                <Space mt={'2vw'}>
                  <SubText color='black'>Arkivet.co</SubText>
                </Space>
                <SubText>
                  We’re especially happy to announce our good friends at{' '}
                  <a href='https://beta.arkivet.co' rel='noopener noreferrer' target='_blank'>
                    Arkivet
                  </a>{' '}
                  are live and kicking! Design, UX and code by yours truly.
                </SubText>
              </Box>

              <Box px={['2.9411764706vw', '0.9765625vw']}>
                <Image src={newsMuch} alt='' />
                <Space mt={'2vw'}>
                  <SubText color='black'>New client</SubText>
                </Space>
                <SubText>
                  We’re excited to announce that Munchmuseet has chosen Feed for a new project
                  launching in 2019.
                </SubText>
              </Box>

              <Box px={['2.9411764706vw', '0.9765625vw']}>
                <Image src={newsOya} alt='' />
                <Space mt={'2vw'}>
                  <SubText color='black'>The Øya books keep winning</SubText>
                </Space>
                <SubText>
                  Diploma in Most Beautiful Norwegian Books (ÅVB) makes for double digit awards this
                  year.
                </SubText>
              </Box>

              <Box px={['2.9411764706vw', '0.9765625vw']}>
                <Image src={newsHelle} alt='' />
                <Space mt={'2vw'}>
                  <SubText color='black'>Meet Helle Holmsen</SubText>
                </Space>
                <SubText>
                  We’re really proud to announce that Helle Holmsen has joined our team of
                  developers.{' '}
                  <a href='https://feed-as.homerun.co' target='_blank'>
                    Do you want to join as well?
                  </a>
                </SubText>
              </Box>

              <Box px={['2.9411764706vw', '0.9765625vw']}>
                <Image src={newsSpeak} alt='' />
                <Space mt={'2vw'}>
                  <SubText color='black'>Let the code speak, god dammit</SubText>
                </Space>
                <SubText>
                  A quick and fun little thing we made to{' '}
                  <a href='https://letthecodespeak.reaktor.com/' target='_blank'>
                    recruit developers to Reaktor
                  </a>
                </SubText>
              </Box>

              <Box px={['2.9411764706vw', '0.9765625vw']}>
                <Image src={newsCopyright} alt='' />
                <Space mt={'2vw'}>
                  <SubText color='black'>Revising the Copyright Act</SubText>
                </Space>
                <SubText>
                  The long fought battle for a revised Copyright Act prevailed, and we designed the
                  book to prove it.
                </SubText>
              </Box>

              <Box px={['2.9411764706vw', '0.9765625vw']}>
                <Image src={newsAi} alt='' />
                <Space mt={'2vw'}>
                  <SubText color='black'>100.000+ signups!</SubText>
                </Space>
                <SubText>
                  More than 113.000 people from around the world has signed up{' '}
                  <a href='https://elementsofai.com' target='_blank'>
                    for the free AI course
                  </a>{' '}
                  we built with Reaktor and the University of Helsinki.
                </SubText>
              </Box>
            </Carousel>
          </Flex>

          <Container>
            <Row mt={['30px', '7.65625vw']} mb={['40px', '8.59375vw']}>
              <Column
                width={10 / 12}
                ml={[0, 'calc(100% / 12 * 1)', 'calc(100% / 12 * 2)']}
                mr={[0, 'calc(100% / 12 * 1)', 'calc(100% / 12 * 2)']}
              >
                <Space mb={'4vw'}>
                  <H1>What we do</H1>
                </Space>
                <Text>
                  We are a dedicated team of experienced designers, developers and business
                  strategists. We conceptualize, design and develop digital products and services,
                  brand identities, environments and printed matter. We use insight, design and
                  technology as tools to seek clarity and help businesses and organizations both
                  define and reach their goals.
                </Text>
              </Column>
            </Row>
          </Container>

          <Footer />
        </Fragment>
      </Layout>
    )
  }
}

export default IndexPage
